import { stdObject } from "./types/stdObject";

export const noTotalsList = [
  "C2",
  "D1",
  "D2",
  "D3",
  "D4",
  "D6",
  "D8",
  "D11",
  "D12",
  "F4",
  "F5",
  "F10",
  "V1",
  "Z1",
  "Z2",
  "Z3",
  "Z4",
  "Z5",
  "Z6",
  "Z7",
  "Z8",
  "Z10",
  "Z11",
  "Z12",
  "Z14",
];

export const screensSearch: stdObject = {
  C2: {
    code: "C2",
    service: "getMonthData",
    list: [
      { CODCAB: "MONSEV", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "month" },
    ],
    search: false,
    print: false,
    save: false,
  },
  D1: {
    code: "IRE",
    service: "getSalesReport",
    list: [
      { CODCAB: "SCHIRE", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
      { CODCAB: "FECIRE", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "date" },
      { CODCAB: "FEC3IRE", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "oneDate" },
      { CODCAB: "HORIRE", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "time" },
    ],
    search: true,
    print: true,
    xls: true,
    save: true,
  },
  D2: {
    code: "ICO",
    service: "getCommissionsReport",
    staff: "PER",
    status: "ESTD2",
    list: [
      { CODCAB: "PERICO", BUSCAB: 1, MODCAB: 0, TITCAB: 1, initValue: true },
      {
        CODCAB: "ESTD2ICO",
        BUSCAB: 1,
        MODCAB: 0,
        TITCAB: 1,
        type: "select",
      },
      { CODCAB: "FECICO", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "date" },
    ],
    search: true,
    print: true,
    xls: true,
    save: false,
  },
  D3: {
    code: "SHI",
    list: [{ CODCAB: "FECSHI", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "date" }],
    search: true,
  },
  D4: {
    code: "DIA",
    list: [],
  },
  D6: {
    code: "ICA",
    service: "getAccountingReport",
    list: [
      { CODCAB: "CUEICA", BUSCAB: 1, MODCAB: 0, TITCAB: 1 },
      { CODCAB: "FECICA", BUSCAB: 1, MODCAB: 0, TITCAB: 1 },
    ],
    search: true,
    print: true,
    xls: true,
    save: false,
  },
  D11: {
    code: "REN",
    service: "getItemsMovProfit",
    list: [
      // { CODCAB: "ARTMOV", BUSCAB: 1, MODCAB: 1, TITCAB: 1, type: "text" },
      // { CODCAB: "NOMMOV", BUSCAB: 1, MODCAB: 3, TITCAB: 1, type: "text" },
      { CODCAB: "FECREN", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "date" },
    ],
    search: true,
    print: true,
    xls: true,
  },
  D12: {
    code: "HIS",
    service: "getRecordsReport",
    list: [
      { CODCAB: "PERHIS", BUSCAB: 1, MODCAB: 0, TITCAB: 1 },
      { CODCAB: "AREHIS", BUSCAB: 1, MODCAB: 0, TITCAB: 1 },
      { CODCAB: "ACNHIS", BUSCAB: 1, MODCAB: 0, TITCAB: 1 },
      { CODCAB: "CODHIS", BUSCAB: 1, MODCAB: 0, TITCAB: 1, MSECAB: false },
      { CODCAB: "NOMHIS", BUSCAB: 1, MODCAB: 0, TITCAB: 1, MSECAB: false },
      { CODCAB: "FECHIS", BUSCAB: 1, MODCAB: 0, TITCAB: 1 },
    ],
    search: true,
    print: true,
    xls: true,
    save: false,
  },
  F1: {
    code: "CAT",
    list: [],
  },
  F3: {
    code: "MAR",
    list: [],
  },
  F4: {
    code: "MOV",
    service: "getItemsMovements",
    list: [
      // { CODCAB: "ARTMOV", BUSCAB: 1, MODCAB: 1, TITCAB: 1, type: "text" },
      // { CODCAB: "NOMMOV", BUSCAB: 1, MODCAB: 3, TITCAB: 1, type: "text" },
      { CODCAB: "FECMOV", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "date" },
    ],
    search: true,
    print: true,
    xls: true,
  },
  F5: {
    code: "BAT",
    service: "getBatchesMovements",
    list: [
      { CODCAB: "CODBAT", BUSCAB: 1, MODCAB: 1, TITCAB: 1, type: "text" },
      { CODCAB: "BATBAT", BUSCAB: 1, MODCAB: 1, TITCAB: 1, type: "text" },
    ],
    search: true,
  },
  F10: {
    code: "INV",
    service: "getInventory",
    list: [
      { CODCAB: "CODINV", BUSCAB: 1, MODCAB: 1, TITCAB: 1, type: "text" },
      { CODCAB: "NOMINV", BUSCAB: 1, MODCAB: 3, TITCAB: 1, type: "text" },
      { CODCAB: "FECINV", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "date" },
    ],
    search: true,
  },
  LOG: {
    code: "LOG",
    service: "getLogAccess",
    list: [
      // { CODCAB: "CODLOG", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
      // { CODCAB: "NOMLOG", BUSCAB: 1, MODCAB: 3, TITCAB: 1, type: "text" },
      { CODCAB: "FECLOG", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "date" },
    ],
    search: true,
  },
  Z1: {
    code: "GEN",
    list: [
      {
        CODCAB: "CODGEN",
        BUSCAB: 1,
        MODCAB: 0,
        TITCAB: 0,
        type: "select",
      },
    ],
  },
  Z2: {
    code: "USU",
    list: [{ CODCAB: "ROLUSU", BUSCAB: 1, MODCAB: 0, TITCAB: 1 }],
  },
  Z3: {
    code: "SUC",
    list: [
      {
        CODCAB: "CODSUC",
        BUSCAB: 1,
        MODCAB: 0,
        TITCAB: 0,
        type: "select",
      },
    ],
  },
  Z4: {
    code: "ADM",
    list: [
      {
        CODCAB: "CODADM",
        BUSCAB: 1,
        MODCAB: 0,
        TITCAB: 0,
        type: "select",
      },
    ],
  },
  Z5: {
    code: "PER",
    list: [
      { CODCAB: "FIEPER", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
    ],
  },
  Z6: {
    code: "BCK",
    list: [],
    search: true,
  },
  Z7: {
    code: "ISU",
    list: [
      {
        CODCAB: "CODISU",
        BUSCAB: 1,
        MODCAB: 0,
        TITCAB: 0,
        type: "select",
      },
      {
        CODCAB: "CODFOR",
        BUSCAB: 1,
        MODCAB: 0,
        TITCAB: 0,
        type: "select",
      },
    ],
  },
  Z8: {
    code: "ACO",
    list: [
      {
        CODCAB: "CODACO",
        BUSCAB: 1,
        MODCAB: 0,
        TITCAB: 0,
        type: "select",
      },
    ],
  },
  Z9: {
    code: "WEB",
    list: [
      { CODCAB: "CODWEB", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
    ],
    settings: true,
  },
  Z10: {
    code: "CAB",
    list: [
      { CODCAB: "GRUCAB", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
      { CODCAB: "USUCAB", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
    ],
  },
  Z11: {
    code: "LAN",
    list: [
      { CODCAB: "GRULAN", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
    ],
  },
  Z12: {
    code: "STA",
    list: [
      { CODCAB: "SECTSTA", BUSCAB: 1, MODCAB: 0, TITCAB: 1, type: "select" },
    ],
    import: true,
    export: true,
  },
  Z14: {
    code: "ROL",
    list: [],
  },
};
